import { render } from "./typesOfbuildings.vue?vue&type=template&id=9df2671c&scoped=true"
import script from "./typesOfbuildings.vue?vue&type=script&lang=js"
export * from "./typesOfbuildings.vue?vue&type=script&lang=js"

import "./typesOfbuildings.vue?vue&type=style&index=0&id=9df2671c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df2671c"]])

export default __exports__